<template>
  <div
    class="detail-payment-pages px-4 py-5"
    style="padding-bottom: 200px !important"
  >
    <loading :show-loading="showLoading" />
    <h3 class="mb-3 font-size-18 fw-bold">{{ $t("esim_info_detail") }}</h3>
    <div class="mb-3">
      <van-cell-group v-if="item" class="list-detail-payment">
        <van-cell class="">
          <template #title>{{ $t("esim_order_code") }}: </template>
          <template #value
            >{{ item.orderCode ? item.orderCode : "" }}
          </template>
        </van-cell>
        <van-cell class="">
          <template #title>{{ $t("esim_full_name") }}: </template>
          <template #value>{{ item.fullName }} </template>
        </van-cell>
        <van-cell class="">
          <template #title>{{ $t("esim_id_number") }}: </template>
          <template #value>{{ item.idNumber }} </template>
        </van-cell>
        <van-cell class="">
          <template #title>{{ $t("esim_dob") }}: </template>
          <template #value>{{ item.dob || "" }}</template>
        </van-cell>
        <van-cell class="">
          <template #title>{{ $t("esim_phone_number") }}: </template>
          <template #value>{{ item.phoneNumber }}</template>
        </van-cell>
        <van-cell class="" v-if="showBuyEsimPriceRows">
          <template #title>{{ $t("esim_phone_number_price") }}: </template>
          <template #value>${{ formatNumber(item.phoneNumberPrice) }}</template>
        </van-cell>
        <van-cell class="" v-if="item.packageName">
          <template #title>{{ $t("esim_package") }}: </template>
          <template #value>{{ item.packageName }} </template>
        </van-cell>
        <van-cell class="" >
          <template #title>{{ $t("esim_package_price") }}: </template>
          <template #value 
            >{{ item.packagePrice ? "$"+formatNumber(item.packagePrice) : "$0.00" }}
          </template>
        </van-cell>
        <van-cell class="" v-if="showBuyEsimPriceRows">
          <template #title>{{ $t("esim_fee") }}: </template>
          <template #value>${{ formatNumber(item.fee) }} </template>
        </van-cell>
        <van-cell class="">
          <template #title
            ><strong>{{ $t("esim_payment_total_prices") }}:</strong></template
          >
          <template #value>
            <span class="fw-bold font-size-16" style="color: #00ba00">
              ${{ formatNumber(item.totalAmount) }}
            </span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-2 mb-3">
      <van-icon name="warning" size="24px" :style="{ color: '#4A4A4A99' }" />
      <p class="mb-0" :style="{ color: '#00000099' }">
        {{ $t("esim_payment_timeout_warning") }}
      </p>
    </div>
  </div>
  <div class="fixed-bottom cs-fixed-bottom">
    <div :style="{ padding: '16px' }">
      <!-- <div class="payment-method">
                        <div class="d-flex justify-content-start gap-2 mb-2">
                            <div :style="{ width: '40px ' }">
                                <img src="@/static/icon_aba_pay.png" class="img-fluid rounded-1" />
                            </div>
                            <p class="mb-0 text-uppercase fw-bold">ABA PAY</p>
                        </div>
                        <div class="d-flex justify-content-between gap-3 mb-3">
                            <div>
                                <p class="mb-0" :style="{ lineHeight: '0.75em' }">Saving Account</p>
                                <span class="font-size-12" :style="{ color: '#00000099' }">000 123 569 | USD </span>
                            </div>
                            <div class="d-flex justify-content-center align-items-center gap-1" @click="handleSelectPayment">
                                <p class="mb-0 text-primary">Change</p>
                                <van-icon name="arrow-down" color="#C41627" />
                            </div>
                        </div>
                    </div> -->

      <div
        class="credit-card"
        v-if="defaultAcc && defaultAcc.accountName != ''"
      >
        <!-- <div class="credit-card"> -->
        <!--        <div class="credit-card">-->
        <!-- <div class="credit-card"> -->
        <div style="">
          <div
            class="icon-aba-pay d-flex justify-content-start align-items-center gap-2"
          >
            <img class="credit-card-image" src="@/static/abapay.svg" />
            <span
              class="credit-card-title fw-bold"
              :style="{ fontSize: '15px' }"
              >ABA PAY</span
            >
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding: 16px 0px;
            "
          >
            <div class="payment-account">
              <div
                class="saving-account savingname-container fw-bold limited-text"
              >
                {{ defaultAcc.accountName }}
              </div>
              <span class="credit-card-phone">
                {{ formatPhoneNumber(defaultAcc.accountNumber) }} |
                {{ defaultAcc.currency }}
              </span>
            </div>

            <div
              :class="{ disabled: showLoading }"
              class="saving-change"
              @click="((showLoading = true), debouncedHandleClick(false))"
            >
              <div class="d-flex justify-content-center align-items-center">
                <div>
                  {{ $t("fuction_change") }}
                </div>
                <!-- <div style="width: 16px; height: 16px" class="d-flex justify-content-center">
                                    <img class="saving-change-icon" src="@/static/icon-change-pay.svg"
                                        alt="icon change" />
                                </div> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_1155_2991)">
                    <path
                      d="M13.3333 5.33329L7.99992 10.6666L2.66659 5.33329"
                      stroke="#c41627"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1155_2991">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 16 16)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-button
        @click="
          ((showLoading = true), debouncedHandleClick(checkDefaultAccount()))
        "
        class="btn-esim-payment"
        block
      >
        <span class="mb-0 me-2">{{ $t("esim_pay") }}</span>
        <span class="mb-0 fw-bold" v-if="item"
          >${{ formatNumber(item?.totalAmount) }}</span
        >
      </van-button>
    </div>
  </div>
  <div v-if="showPaymentMethod == true">
    <PaymentMethod />
  </div>
</template>
<script>
import { Divider, Cell, CellGroup, SubmitBar, FloatingPanel } from "vant";
import PaymentMethod from "@/components/payment-method.vue";
import { CONSTANTS } from "@/helpers/constants";
import { ESIM_ORDER_FLOW } from "@/helpers/esimFlow";
import { mapState } from "vuex";
import { formatToDateDDMMYYYY } from "@/ultis/dateFormat";
import { encrypt, sign, keyToPem } from "anhdev99.rsa";
import {
  formatDateToDDMMYYYYHHMMSS,
  formatDateToDDMMYYYY,
  formatDateToEN_US,
} from "@/ultis/dateFormat";
import Loading from "@/components/loading";
import _ from "lodash";
import store from "@/store";

export default {
  name: "Detail",
  components: {
    Loading,
    [Divider.name]: Divider,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [SubmitBar.name]: SubmitBar,
    [FloatingPanel.name]: FloatingPanel,
    PaymentMethod,
  },
  data() {
    return {
      showPaymentMethod: false,
      switchChecked: false,
      payment: {
        amount: "",
        account: "",
        currency: "USD",
        additionalKey: {
          autoRenew: false,
          msisdn: "",
          hash: "",
          remark: "",
        },
      },
      defaultAcc: {
        accountName: "",
        accountNumber: "",
        currency: "",
      },
      showLoading: false,
      transactionId: "",
      paramsCheckStatus: {
        invoice: "",
        ccy: "",
        state: "",
        total_amount: "",
        original_amount: "",
      },

      remarkInfo: null,
      dataGetStatus: null,
    };
  },
  async created() {
    //await this.getDefaultAcc();
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("esimBuyStore", ["detailPaymentInfo"]),
    ...mapState("headerStore", ["title"]),

    item() {
      return this.detailPaymentInfo;
    },

    getPrice() {
      return this.item?.totalAmount ?? 0;
    },
    /** Chỉ luồng đổi eSIM ẩn giá số / phí; buy hoặc không set flowType vẫn hiện. */
    showBuyEsimPriceRows() {
      return this.item?.flowType !== ESIM_ORDER_FLOW.CHANGE;
    },
  },

  async mounted() {
    this.$bridge.registerHandler("getStatus", async (data) => {
      if(this.dataGetStatus){ 
        return;
      }
      this.dataGetStatus = data;
      await this.handleGetStatus(data); 
    });
    this.changeTitle(this.$t(this.title));
  },
  watch: {
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "esim_payment");
      },
      immediate: true,
    },
  },
  methods: {
    
    async getDetailOrder(){
      let params = {};
      const defaultParam = this.stateAsObject(this.defaultParam);
      console.log("defaultParam: ", defaultParam);
      params = {
        ...defaultParam,
        orderCode: this.remarkInfo.orderCode || "", 
        pageNumber: 1,
        pageSize: 10,
        fromDate: formatDateToDDMMYYYY(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)),
        toDate: formatDateToDDMMYYYY(new Date()),
      };
      console.log("params: ", params);

      this.$store
        .dispatch("esimMetfoneStore/getHistories", params)
        .then((res) => {
          if (res) {
            const result = res.data;

            if (result.errorCode === 0) {
              
              const orderedNumbers = result?.orderedNumbers || []; 
              const detailInfo = orderedNumbers.find(
                (num) => num.orderCode === this.remarkInfo.orderCode
              );

              if (detailInfo) {
                this.resultSuccess = {
                  isdn: detailInfo.phone,
                  qrCode: detailInfo.qrCode,
                  serial: detailInfo.serial ||  "xxxx-xxxx-xxxx",
                  simExpireDate: detailInfo.expiredTime,
                };
                this.$router.replace({
                  path: "esim/payment-success",
                  query: this.resultSuccess,
                });
              }
              else{
                this.$notify({
                  code: 1,
                  message: `${this.$t("esim_order_unsuccessful")}`,
                });
              } 
            } else {
              this.$notify({
                code: result.errorCode,
                message: result.message,
                onClose: () => {
                  this.$router.replace({
                    path: "/home",
                    query: { tab: "buyMetfoneEsim" },
                  });
                },
              });
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async handleGetStatus(data){
      console.log("Data from native getStatus: ", data);
      this.showLoading = true;
      await this.timeout(1000); 
      if (data) {
        this.transactionId = data.transactionId;      
        const params = this.stateAsObject(this.defaultParam); 
        params.orderRef = data.orderRef;
        params.transactionId = data.transactionId;
        params.transactionDate = data.transactionDate;
        params.debitAmount = data.debitAmount;
        params.debitCcy = data.debitCcy;
        params.remark = this.remarkInfo.remark
        params.secretKey = data.secretKey
        await this.$store
          .dispatch("metfoneStore/transactionCallback", params)
          .then(async (res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                await this.getDetailOrder(); 
              } else {
                this.$notify({
                  code: result.errorCode,
                  message: result.message,
                  onClose: () => {
                    this.$router.replace({
                      path: "/home",
                      query: { tab: "buyMetfoneEsim" },
                    });
                  },
                });
              }
            }
          });
        this.showLoading = false;
      }
    },

    // BUY_ESIM, CHANGE_ESIM, BUY_TV360
    async getRemark(transactionType = "BUY_ESIM") {
      let mes = `<data>
        <merchantAccount>WING</merchantAccount>
        <transactionType>${transactionType}</transactionType>
        <partnerAccount>${this.profile.id}</partnerAccount>       
        <orderCode>${this.item.orderCode}</orderCode>
      </data>`;
      console.log("getRemark Mes: ", mes); 
      const params = this.stateAsObject(this.defaultParam);
      const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
      const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
      params.signature = sign(mes, privateKeyPem);
      params.encrypt = encrypt(mes, publicKeyPem);
      const res = await this.$store.dispatch("metfoneStore/getRemark", params)
      if (res) {
        let result = res.data;
        if (result && result.errorCode == 0) { 
          this.remarkInfo = result.remarkInfo;
          console.log("remarkInfo: ", this.remarkInfo);
          return true;
        } else {
          this.$store.dispatch("notifyStore/addNotify", {
            code: 1,
            message: result.message,
          });
          return false;
        }
      }
      return false;
    },

    async handleBuy() {
      console.log("Package info", this.item); 

      let phoneNumber = "";
      if (this.profile) {
        phoneNumber = this.profile.phone
          ? this.formatSpacingPhoneNumber(this.profile.phone)
          : "";
      }

      let getRemarkRes = await this.getRemark("BUY_ESIM");
      if (!getRemarkRes) {
        this.showLoading = false;
        return;
      } 
      this.resetPaymentPayload(); 
      this.payment.amount = Number(this.getPrice || 0).toFixed(2); 
      this.payment.currency = "USD";
      this.payment.useDefault = true;  

      this.payment.account = this.remarkInfo.orderCode;
      this.payment.appId = this.profile.appId;

      this.payment.additionalKey.autoRenew = this.switchChecked;
      this.payment.additionalKey.msisdn = phoneNumber || "";
   
      this.payment.additionalKey.hash = this.remarkInfo.hash;
      this.payment.secretApiKey = CONSTANTS.SECRET_API_KEY;
 
      // Adđ remark
      let remarkText = this.item.phoneNumber ? this.item.phoneNumber : "";
      if (remarkText.startsWith("855")) {
        remarkText = remarkText.slice(3);
      }
      if (remarkText.startsWith("0")) {
        remarkText = remarkText.slice(1);
      }

      //this.item.serviceName
      if (
        !this.item.packageCode ||
        this.item.packageCode == undefined ||
        this.item.packageCode == ""
      ) {
        remarkText = `eSIM : ${remarkText}`;
      } else {
        //remarkText = `eSIM + DataOsja : ${remarkText}`;
        remarkText = `eSIM + DataOsja : ${remarkText}`;
      }
      this.payment.additionalKey.remark = remarkText;

      if (process.env.VUE_APP_BYPASS_NATIVE_API === "false") {
        console.log("[==> doPayment]", this.payment); 
        this.$bridge
          .callHandler("doPayment", this.payment)
          .then((data) => {
            console.log("doPayment then ", data)
          })
          .finally(() => {
            console.log("doPayment finally")
          });
      }
      else{
        console.log("[==> FAKE doPayment]", this.payment);
        await this.handleGetStatus({
          transactionId:"tran_" + new Date().getTime(),
        });
      }
      
      setTimeout(() => {
        this.showLoading = false;
      }, 500);
    },

    formatNumber(value) {
      const number = parseFloat(value);
      if (Number.isNaN(number)) return "0.00";
      return number.toFixed(2);
    },
  

    color_primary() {
      return CONSTANTS.color_primary;
    },
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    },
    formatToDateDDMMYYYY,
    formatSpacingPhoneNumber(phone) {
      return phone.replace(/ /g, "");
    },
    formatPhoneNumber(phoneNumber) {
      phoneNumber = phoneNumber.replace(/\D/g, "");

      if (phoneNumber.length >= 7) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{3,4})/, "$1 $2 $3");
      }

      return phoneNumber;
    },
    async timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    debouncedHandleClick: _.debounce(function (useDefaultAcc = false) {
      this.handleBuy();
    }, 200),
    resetPaymentPayload() {
      this.payment = {
        amount: "0",
        currency: "",
        useDefault: false,
        account: "", // something that unique like transaction_id|invioce_id|ticket_id
        additionalKey: {
          autoRenew: false,
          hash: "",
          remark: "",
        },
      };
      this.dataGetStatus = null;
    },
    getCurrentUnixTimestamp() {
      return Math.floor(Date.now() / 1000); // trả về timestamp dạng giây
    },

    

    async handleSelectPayment(val) {
      if (val) await this.getDefaultAcc();
      // this.showPaymentMethod = val;
    },

    async getDefaultAcc() {
      if (this.getPrice != "0") {
        this.$bridge
          .callHandler("getDefaultAcc", {
            currency: "USD",
            amount: this.getPrice,
            // amount: 20000000000,
          })
          .then((res) => {
            console.log("res1222444");
            console.log(res);
            if (res && res.accountName) this.defaultAcc = res;
            else {
              this.defaultAcc.accountName = "";
              this.defaultAcc.accountNumber = "";
              this.defaultAcc.currency = "USD";
            }
          });
      }
    },
    checkDefaultAccount() {
      if (
        this.defaultAcc == null ||
        this.defaultAcc == undefined ||
        (this.defaultAcc && this.defaultAcc.accountName == "")
      )
        return false;
      return true;
    },

   
    async callPaymentChangeSim(checkStatusResult, accountABA) {
      try {
        const transIdeKYC = this.item.transIdeKYC || "";
        if (!transIdeKYC) {
          console.error("Missing transIdeKYC");
          this.showLoading = false;
          return;
        }

        const paymentReference =
          checkStatusResult.checkStatusResponseDTO?.paymentReference || "";

        const mes = `<data>
          <merchantAccount>MINI_APP</merchantAccount>
          <isdn>${this.item.phoneNumber || ""}</isdn>
          <orderCode>${this.item.orderCode || ""}</orderCode>
          <idType>${this.item.idType}</idType>
          <idNumber>${this.item.idNumber || ""}</idNumber>
          <accountABA>${accountABA}</accountABA>
          <fullName>${this.item.fullName || ""}</fullName>
          <dob>${this.item.dob || ""}</dob>
          <gender>${this.item.gender || ""}</gender>
          <province>${this.item.province || ""}</province>
          <transIdeKYC>${transIdeKYC}</transIdeKYC>
          <paymentReference>${paymentReference}</paymentReference>
          </data>`;

        console.log("Mes paymentChangeSim: ", mes);

        const params = this.stateAsObject(this.defaultParam);
        delete params.env;
        const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
        const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
        params.signature = sign(mes, privateKeyPem);
        params.encrypt = encrypt(mes, publicKeyPem);

        const res = await this.$store.dispatch(
          "esimMetfoneStore/paymentChangeSim",
          params,
        );

        if (res) {
          this.$store.dispatch("esimBuyStore/detailPaymentInfo", null);
          const result = res.data;
          if (result && result.errorCode == 0) {
            this.resultSuccess = {
              isdn: result.isdn,
              qrCode: result.qrContent,
              serial: result.serial || "xxxx-xxxx-xxxx",
              simExpireDate: result.simExpireDate || "",
            };
            this.$router.replace({
              path: "esim/payment-success",
              query: this.resultSuccess,
            });
          } else {
            this.$notify({
              code: result?.errorCode || 1,
              message: result?.message || this.$t("esim_order_unsuccessful"),
              onClose: () => {
                this.$router.replace({
                  path: "/home",
                  query: { tab: "buyMetfoneEsim" },
                });
              },
            });
          }
        } else {
          this.$notify({
            code: 1,
            message: `${this.$t("esim_order_unsuccessful")}`,
          });
        }
      } catch (error) {
        console.error("Error in callPaymentChangeSim:", error);
        this.$notify({
          code: 1,
          message: `${this.$t("esim_order_unsuccessful")}`,
        });
      }
    },

    async callBuyEsimABA(checkStatusResult, accountABA) {
      try {
        let transIdeKYC = this.item.transIdeKYC || "";
        if (!this.item.transIdeKYC) {
          console.error("Missing transIdeKYC");
          this.showLoading = false;
          return;
        }

        let mes = `<data>
            <merchantAccount>MINI_APP</merchantAccount>
            <isdn>${this.item.phoneNumber}</isdn>  
            <orderCode>${this.item.orderCode}</orderCode>
            <idType>${this.item.idType}</idType>
            <idNumber>${this.item.idNumber}</idNumber>
            <accountABA>${accountABA}</accountABA>
            <fullName>${this.item.fullName}</fullName>
            <dob>${this.item.dob}</dob>
            <gender>${this.item.gender}</gender>
            <province>${this.item.province}</province>
            <packageCode>${this.item.packageCode}</packageCode>
            <packageName>${this.item.packageName}</packageName>
            <packagePrice>${this.item.packagePrice}</packagePrice>
            <isdnPrice>${this.item.phoneNumberPrice}</isdnPrice>
            <transIdeKYC>${transIdeKYC}</transIdeKYC>
            <paymentReference>${checkStatusResult.checkStatusResponseDTO.paymentReference}</paymentReference>
            <totalAmount>${this.item.totalAmount}</totalAmount>
        </data>`;

        console.log("Mes E payment: ", mes);

        const params = this.stateAsObject(this.defaultParam);
        const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
        const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
        params.signature = sign(mes, privateKeyPem);
        params.encrypt = encrypt(mes, publicKeyPem);

        console.log("buyEsimABA params:", params);

        const res = await this.$store.dispatch(
          "esimMetfoneStore/buyEsimABA",
          params,
        );

        if (res) {
          this.$store.dispatch("esimBuyStore/detailPaymentInfo", null);
          let result = res.data;
          if (result && result.errorCode == 0) {
            this.resultSuccess = {
              isdn: result.isdn,
              qrCode: result.qrContent,
              serial: result.serial || "xxxx-xxxx-xxxx",
              simExpireDate: result.simExpireDate,
            };
            this.$router.replace({
              path: "esim/payment-success",
              query: this.resultSuccess,
            });
          } else {
            this.$notify({
              code: result.errorCode,
              message: result.message,
              onClose: () => {
                this.$router.replace({
                  path: "/home",
                  query: { tab: "buyMetfoneEsim" },
                });
              },
            });
          }
        } else {
          this.$notify({
            code: 1,
            message: `${this.$t("esim_order_unsuccessful")}`,
          });
        }
      } catch (error) {
        console.error("Error in callBuyEsimABA:", error);
        this.$notify({
          code: 1,
          message: `${this.$t("esim_order_unsuccessful")}`,
        });
      }
    },
  },
};
</script>
<style>
.detail-payment-pages {
  background-color: #fff !important;
  min-height: 100vh;
}

.list-detail-payment.van-hairline--top-bottom::after {
  border-top: 0 !important;
}

.list-detail-payment .van-cell {
  padding: 8px 0px !important;
}

.list-detail-payment .van-cell:last-child::after {
  border-bottom: none !important;
}

.cs-fixed-bottom {
  background: #fff !important;
  width: 100%;
  box-shadow: rgba(33, 35, 38, 0.1) 0px -10px 20px -10px;
}

.credit-card-phone {
  /* font-family: "Inter" !important; */
  opacity: 0.5;
  color: #000;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.credit-card-title {
  color: #000;
  /* font-family: "Inter" !important; */
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 18px;
}

.saving-account {
  /* font-family: "Inter" !important; */
  font-size: 16px;
}

.btn-esim-payment {
  min-width: 343px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: #c41627;
  color: #fff !important;
  /* font-family: "Inter" !important; */
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.066px;
  border: none !important;
  padding-top: 13px !important;
  padding-bottom: 13px !important;
}

.btn-esim-payment * {
  /* font-family: "Inter" !important; */
}

.icon-aba-pay {
  display: flex;
  justify-content: start;
  align-items: center;
}

.saving-change {
  color: #c41627;
  text-align: right;
  /* font-family: "Inter" !important; */
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.066px;
}

.saving-change * {
  /* font-family: "Inter" !important; */
}

.limited-text {
  max-width: 193px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.credit-card-image {
  background-color: #005d85;
  image-rendering: pixelated;
  height: 18px;
  width: 30px;
  border-radius: 5px;
}
</style>
